import { useSelector, useDispatch } from "react-redux";
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CSubheader,
} from "@coreui/react";

import { showDashboard } from "../../redux/actions/dashboard";
import { RootState } from "../../store";

import { HeaderDropdown } from "./index";
import HeaderDropdownNotif from "./HeaderDropdownNotif";
import Select from "react-select";
import { setTaxPayer } from "../../redux/tax-payer/tax-payer-slice";
import TaxPayer from "../../models/tax-payer";
import ThemeToggle from "./ThemeToggle";
import { rememberSelectedTaxPayer } from "../../utils/tax-payer-selection";

const Header = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state: RootState) => state.user.id);
  const sidebarShow = useSelector(
    (state: RootState) => state.dashboard.sidebarShow,
  );

  const userTaxPayers = useSelector(
    (state: RootState) => state.taxPayer.data.userTaxPayers,
  );

  const taxPayer = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer,
  );

  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    dispatch(showDashboard(val));
    if (val !== "responsive") {
      window.localStorage.setItem("sidebarShow", val ? "true" : "false");
    } else {
      window.localStorage.setItem("sidebarShow", "responsive");
    }
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch(showDashboard(val));
    if (val !== "responsive") {
      window.localStorage.setItem("sidebarShow", val ? "true" : "false");
    } else {
      window.localStorage.setItem("sidebarShow", "responsive");
    }
  };

  const onTaxPayerChange = (taxPayer: TaxPayer) => {
    if (!userId || taxPayer.id === undefined) return;
    rememberSelectedTaxPayer(userId, taxPayer.id);
    dispatch(setTaxPayer(taxPayer));
  };

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        {/* <CIcon name="logo" height="48" alt="Logo"/> */}
      </CHeaderBrand>

      {/* Desktop */}
      {userTaxPayers.length > 1 ? (
        <CHeaderNav className="d-md-down-none mr-auto">
          <CHeaderNavItem className="px-1">Contribuyente: </CHeaderNavItem>
          <CHeaderNavItem className="px-1">
            <div style={{ width: "300px" }}>
              <Select
                classNamePrefix="theme-select"
                placeholder="Seleccione un contribuyente"
                noOptionsMessage={() => "No se encontraron"}
                options={userTaxPayers}
                getOptionLabel={(option) =>
                  `${option.ruc} - ${option.socialName}`
                }
                getOptionValue={(option) => `${option.id}`}
                onChange={(option) => {
                  if (option !== null) onTaxPayerChange(option);
                }}
                value={taxPayer}
              />
            </div>
          </CHeaderNavItem>
        </CHeaderNav>
      ) : (
        <CHeaderNav className="d-md-down-none mr-auto"></CHeaderNav>
      )}

      <CHeaderNav className="px-3">
        <ThemeToggle placement="header" />
        <HeaderDropdownNotif />
        <HeaderDropdown />
      </CHeaderNav>

      {/* Móvil: selector de contribuyente en fila separada con ancho completo */}
      {userTaxPayers.length > 1 && (
        <CSubheader
          className="d-lg-none px-3 py-2"
          style={{ display: "flex", alignItems: "center" }}
        >
          <span
            className="mr-2"
            style={{ whiteSpace: "nowrap", lineHeight: 1 }}
          >
            Contribuyente:
          </span>
          <div style={{ flex: 1 }}>
            <Select
              classNamePrefix="theme-select"
              placeholder="Seleccione un contribuyente"
              noOptionsMessage={() => "No se encontraron"}
              options={userTaxPayers}
              getOptionLabel={(option) =>
                `${option.ruc} - ${option.socialName}`
              }
              getOptionValue={(option) => `${option.id}`}
              onChange={(option) => {
                if (option !== null) onTaxPayerChange(option);
              }}
              value={taxPayer}
            />
          </div>
        </CSubheader>
      )}
    </CHeader>
  );
};

export default Header;
